import * as React from 'react'

export const StageIdea = props => (
  <svg
    width={73}
    height={80}
    viewBox="0 0 73 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12632)">
      <path
        d="M33.4674 8.28337C35.2165 7.25772 37.3835 7.25772 39.1326 8.28337L61.2454 21.2497C62.9597 22.2549 64.0128 24.0932 64.0128 26.0805V52.1644C64.0128 54.1516 62.9597 55.9899 61.2454 56.9951L39.1326 69.9614C37.3835 70.9871 35.2165 70.9871 33.4674 69.9614L11.3546 56.9951C9.64033 55.9899 8.58719 54.1516 8.58719 52.1644V26.0805C8.58719 24.0932 9.64033 22.2549 11.3546 21.2497L33.4674 8.28337Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.4902 15.2416C35.2278 14.2336 37.3722 14.2336 39.1099 15.2416L55.8006 24.9233C57.5277 25.9251 58.5908 27.7707 58.5908 29.7673V49.1764C58.5908 51.173 57.5277 53.0186 55.8006 54.0205L39.1099 63.7022C37.3722 64.7101 35.2278 64.7101 33.4902 63.7022L16.7994 54.0205C15.0723 53.0186 14.0093 51.173 14.0093 49.1764V29.7673C14.0093 27.7707 15.0723 25.9251 16.7994 24.9233L33.4902 15.2416Z"
        fill="#428456"
      />
      <path
        d="M36.1012 21.5994C42.1386 21.5994 47.0329 26.6609 47.0329 32.9046C47.0329 35.7615 46.0068 38.369 44.3162 40.3585C43.4623 41.3632 42.8284 42.5931 42.8284 43.9307V44.2097C42.8284 46.6112 40.946 48.5579 38.6239 48.5579H33.5785C31.2565 48.5579 29.374 46.6112 29.374 44.2097V43.9307C29.374 42.5931 28.7401 41.3632 27.8863 40.3585C26.1957 38.369 25.1696 35.7615 25.1696 32.9046C25.1696 26.6609 30.0638 21.5994 36.1012 21.5994Z"
        fill="#FFFAC7"
      />
      <path
        d="M35.4539 43.2503C36.4229 43.2504 37.2086 43.9915 37.2086 44.9056C37.2086 45.8198 36.4229 46.5608 35.4539 46.561C34.4848 46.561 33.6992 45.8199 33.6992 44.9056C33.6992 43.9914 34.4848 43.2503 35.4539 43.2503Z"
        fill="#524F4D"
      />
      <path
        d="M36.0388 25.5932C39.9152 25.5934 43.0578 28.6453 43.0578 32.4097C43.0576 35.3467 41.144 37.848 38.4619 38.8058C37.6722 39.0878 37.0407 39.7444 37.0407 40.5409V40.7274C37.0407 41.511 36.3679 42.1467 35.5373 42.1467C34.7066 42.1467 34.0328 41.511 34.0328 40.7274V38.919C34.0328 37.7325 34.8688 36.6289 36.0388 36.3045C38.2537 36.3044 40.0496 34.5606 40.0498 32.4097C40.0498 30.2587 38.2538 28.515 36.0388 28.5149C34.3279 28.5149 32.8669 29.5547 32.2906 31.0195C32.0016 31.7541 31.354 32.4097 30.5233 32.4097C29.6929 32.4095 29.0036 31.7675 29.1696 31.0001C29.8382 27.912 32.66 25.5932 36.0388 25.5932Z"
        fill="#524F4D"
      />
      <rect
        x="31.1323"
        y="53.5502"
        width="9.93789"
        height="2.99539"
        rx="1.4977"
        fill="#D9D9D9"
      />
      <rect
        x="33.1199"
        y="57.5441"
        width="5.96273"
        height="1.99693"
        rx="0.998464"
        fill="#605C5C"
      />
      <rect
        x="30.1385"
        y="49.5564"
        width="11.9255"
        height="2.99539"
        rx="1.4977"
        fill="#D9D9D9"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12632"
        x="-3.7"
        y="-0.377594"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12632"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12632"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
